import React from 'react';

import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import FormViewButton from 'components/Common/Buttons/FormViewButton';

/* eslint-disable react/prop-types, react/no-unstable-nested-components */
const WorkflowActions = ({ permissions, settings, workflowType, openAccountWithholdingModal, openUnassignFormModal, onTakeQueueItem }) => ({
  id: 'action-column',
  Header: <span className="expand-header-offset">View</span>,
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      { (workflowType === 'complete')
        && AccessControl.hasPermission(
          permissions,
          [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate, ActivityPerms.electronicView, ActivityPerms.electronicValidate]
        )
        && <FormViewButton
          content={ <span className="icon icon-apps" /> }
          className="btn btn-sm"
          title="Reopen"
          formId={ row.original.itemId }
          accountId={ row.original.accountId }
          form={ row.original }
          permissions={ permissions }
        /> }
      { (workflowType !== 'complete')
        && AccessControl.hasPermission(
          permissions,
          [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate, ActivityPerms.electronicView, ActivityPerms.electronicValidate]
        )
          && <button
            className="btn btn-sm"
            type="button"
            title={ workflowType !== 'complete' ? 'Process item' : 'Reopen' }
            onClick={ () => onTakeQueueItem(row.original) }
          >
            <span className="icon icon-apps" />
          </button> }
      { (settings && settings.showWithholding && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]))
        && (!row.original.hasParentAccount && !row.original.hasAllocationStmt)
        && <button
          className="btn btn-sm"
          type="button"
          onClick={ () => openAccountWithholdingModal(row.original, 'forms') }
          title="Show Withholding Rates"
        >
          <span className="icon icon-calculator" />
        </button> }
      { (workflowType === 'mywork') && (((settings && row.original.customerId && row.original.workflowStage === 5)
      || (settings && row.original.customerId && row.original.workflowStage === 7))
          && (
            row.original.formType
            && row.original.formType.toString().toLowerCase() !== 'unknown'
          )
      )
          && <button
            className="btn btn-sm "
            type="button"
            title="Unassign Form"
            onClick={ () => openUnassignFormModal(row.original) }
          >
            <span>
              <span className="icon icon-people-unassign">
                <span />
              </span>
            </span>
            </button> }
    </div>
  ),
  className: 'col-10p'
});
/* eslint-enable react/prop-types, react/no-unstable-nested-components */

export default WorkflowActions;
